import { interval } from 'rxjs';

export class ApiDate {
    date:Date =new Date();
    hour:string;
    min:string;

    constructor() {
        this.date= new Date();
    }
    updateDate() {

        this.date.setHours(parseInt(this.hour), parseInt(this.min), 0,0);
    }
    toString() {
        this.date.toString();        
    }

    getDateToApiFormat() : string{
        this.updateDate();
        return this.date.toISOString();
    }
}